'use client';
import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function SafetyStatsCard() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bento-card bg-card border border-border rounded-lg reveal">
      {/* Header — always visible, tappable on mobile */}
      <div className="flex items-center justify-between p-4 md:p-0 md:block">
        <div className="md:p-0 md:ml-[31px]">
          <span className="text-xs font-mono uppercase tracking-widest text-primary mb-4 block">
            03 / Safety First
          </span>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground md:mb-8">
            Zero Incidents.<br />
            <span className="text-success">Zero Compromise.</span>
          </h2>
        </div>
        {/* Chevron toggle — only visible on mobile */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="md:hidden ml-4 flex-shrink-0 w-8 h-8 rounded-full bg-muted flex items-center justify-center transition-transform duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
          aria-expanded={isExpanded}
          aria-label={isExpanded ? 'Collapse safety stats' : 'Expand safety stats'}
        >
          <Icon
            name="ChevronDownIcon"
            size={16}
            className="text-muted-foreground"
          />
        </button>
      </div>

      {/* Stats: always visible on desktop, collapsible on mobile */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out md:max-h-none md:opacity-100 md:mt-8 ${
          isExpanded ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 md:px-0 pb-4 md:pb-0">
          <div className="space-y-8">
            <div className="industrial-border p-6 bg-card">
              <h3 className="text-5xl font-bold text-success mb-2">0</h3>
              <p className="text-sm font-mono uppercase tracking-widest text-muted-foreground">
                Lost-Time Incidents (5+ Years)
              </p>
            </div>

            <div className="industrial-border p-6 bg-card">
              <h3 className="text-5xl font-bold text-foreground mb-2">1M+</h3>
              <p className="text-sm font-mono uppercase tracking-widest text-muted-foreground">
                Hours Worked Without Incident
              </p>
            </div>

            <div className="industrial-border p-6 bg-card">
              <h3 className="text-5xl font-bold text-foreground mb-2">100%</h3>
              <p className="text-sm font-mono uppercase tracking-widest text-muted-foreground">
                OSHA 30-Hour Certified Safety Coordinator
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
